import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function WorkPreview() {
  const [stories, setStories] = useState([]);
  useEffect(() => {
    axios.get(`${BACKEND}/api/job-stories`).then(({ data }) => setStories(Array.isArray(data) ? data : [])).catch(() => {});
  }, []);
  const thumbs = stories.slice(0, 8);

  return (
    <section className="px-5 lg:px-8 py-14 bg-[#F4F4F5]" data-testid="work-preview">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
          <h2 className="font-display font-black tracking-tighter text-3xl lg:text-4xl text-[#15306E]">Recent jobs</h2>
          <Link to="/our-work" data-testid="work-preview-all" className="inline-flex items-center gap-1.5 text-[#46A01E] font-display font-bold uppercase tracking-wide text-sm hover:underline">
            See all our work <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
        {thumbs.length === 0 ? (
          <p className="text-[#52525B]" data-testid="work-preview-empty">New before-and-after photos are on the way.</p>
        ) : (
          <div className="grid grid-cols-4 sm:grid-cols-8 gap-2">
            {thumbs.map((s) => (
              <Link key={s.id} to="/our-work" data-testid={`work-thumb-${s.id}`} className="block aspect-square overflow-hidden rounded-sm bg-[#E4E4E7] group">
                <img src={`${BACKEND}${s.after_url || s.before_url}?w=320`} decoding="async" alt={`Junk removal job in ${s.neighborhood}`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
